export default "__VITE_ASSET__dc204684__"